export default __webpack_public_path__ + "static/media/virus.34a77146.svg";